module.exports = __webpack_public_path__ + "static/pexels-tom-swinnen-1309766-e306d8a56cf20c2ef2ccf139310fdda9.jpg";